<template>
  <div>
    <b-modal id="serviceConfiguration" title="Service Hands-on-fees" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Service Hands-on-fees
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <table class="table">
              <tr>
                <th>Service</th>
                <th>Hands-on-fee</th>
              </tr>
              <tr v-for="(service, index) in selectedServices" :key="'service_' + index">
                <td>
                  <label class="form-label">{{ service['name'] }}</label>
                </td>
                <td>
                  <input
                  class="form-control"
                  v-model="fee[service['id']]"
                  type="number"
                  :searchable="false"
                  :show-labels="false" />
                </td>
              </tr>
            </table>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "serviceConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},
      fee: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('serviceConfiguration')
      this.loadSection()
    },

    onOutletChange() {
      this.fee = {}
      this.loadCommission()
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {
        if(service['section']['sectionID'] === 0) {
          service['section']['sectionID'] = this.sections[0]['sectionID']
        }
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=1&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_DAsiaWellness_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_DAsiaWellness_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          for (let temp in response.data) {
            let setting = (response.data[temp] || {})
            this.fee[temp] = setting['fee'] || ''
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let service of this.services) {
        request[service['skuID']] = {
          fee: this.fee[service['skuID']],
        }
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_DAsiaWellness_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_DAsiaWellness_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('serviceConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>